const styles = (theme) => ({
	buttomAddUser: {
		color: theme.palette.text.main,
		borderColor: theme.palette.text.main,
		maxWidth: "200px",
		"@media (max-width: 1350px)": {
			maxWidth: "200px",
		},
	},
	searcField: {
		width: "250px",
		display: "flex",
		fontSize: "0.75rem", // diminui fonte geral
		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "8px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
		"@media (max-width: 1349px)": {
			width: "100%",
		},
	},
	clientAutocomplete: {
		width: "200px",
		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "6px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
	},
});

export default styles;
